import { useState, useEffect } from "react";
import throttle from "lodash.throttle";

const useScrolled = (ref, offset = 0) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const listener = throttle(() => {
      if (ref.current) {
        // const { top } = ref.current.getBoundingClientRect();
        setScrolled(Math.ceil(window.scrollY) >= ref.current.offsetTop - offset);
      }
    }, 100);
    document.addEventListener("scroll", listener);
    return () => document.removeEventListener("scroll", listener);
  }, [ref, offset]);

  return scrolled;
};

export default useScrolled;
